// extracted by mini-css-extract-plugin
export default {"deleteButton":"styles_deleteButton__wl5QQ","disabled":"styles_disabled__yYjop"};